module.exports = __webpack_public_path__ + "img/logo_palo.1aa4d823.png";